import React from 'react'
import ReactModal from 'react-modal'

interface IModalProps extends ReactModal.Props {
  children: React.ReactNode
}

export default function Modal({
  children,
  overlayClassName,
  className,
  ...otherProps
}: IModalProps) {
  return (
    <ReactModal
      className={`modal__content ${className || ''}`}
      overlayClassName={`modal__overlay ${overlayClassName || ''}`}
      {...otherProps}>
      {children}
    </ReactModal>
  )
}
